// Notifiation.js
import React, { useEffect, useState } from "react";
import "./CreateExams.css"; // ✅ Uses existing styles

const Notification = ({ message, type, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setVisible(true);

      // Automatically hide notification after 5 seconds
      const timer = setTimeout(() => {
        setVisible(false);
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  return (
    <div className={`notification-popup ${visible ? "show" : "fade-out"} ${type === "success" ? "success" : "error"}`}>
      <ul>
        <li>{message}</li>
      </ul>
    </div>
  );
};

export default Notification;
